const en = {
    "success": 'Successful',
    "failure": 'Failed',
    "project": 'Projects',
    "status": 'Status',
    "start_at": 'Start Time',
    "end_at": 'End Time',
    "assignees": 'Assignee',
    "priority": 'Priority',
    "progress": 'Progress',
    'estimated_time': 'Estimated time',
    "confirm_password_does_not_match": 'Your password and confirmation password do not match',
    "password_invalid": "Password can't contain spaces!",
    "confirm": 'Confirmation',
    "cancel": 'Cancellation',
    "has_error": 'An error occurred',
    "transfer_work": 'Moving tasks',
    "are_you_sure_you_want_to_move_this_task_from_project": 'Are you sure you want to move this task from the project',
    "to_project": 'To project',
    "view_detail": 'View more details',
    "effort": 'Performance',
    "score":'Scores',
    "result":'Result',
    "comment": 'Comment',
    "name_evaluation":'Name of evaludation',
    "date": 'Date',
    "notes_cannot_be_empty": 'Notes content cannot be empty',
    "confirm_deletion_timekeeping": 'Are you sure you want to delete this timesheet',
    "time_checkin": "Check in time",
    "time_checkout": "Check out time",
    "not_check": "Not check",
    "working_time": "Man-hour",
    "time_in":"In ",
    "time_out":"Out ",
    "remaining_leave_hours": "Number of leave hours",
    "delete_timekeeping": 'Delete timesheet! ',
    "delete_timekeeping_success": 'This timesheet is successfully deleted',
    "start" : 'Start',
    "finish" : 'Finish',
    "start_task" : 'Start task',
    "finish_task" : 'Finish task',
    "category": 'Categories',
    "item": 'Subsection',
    "description": 'Description',
    "select_members":'Select one or more members',
    "error_position":'Please select position',
    "error_member":'Please select members',
    'january': 'January',
    'february': 'February',
    'march': 'March',
    'april': 'April',
    'may': 'May',
    'june': 'June',
    'july': 'July',
    'august': 'August',
    'september': 'September',
    'october': 'October',
    'november': 'November',
    'december': 'December',

    'Su': 'Sunday',
    'Mo': 'Monday',
    'Tu': 'Tuesday',
    'We': 'Wednesday',
    'Th': 'Thursday',
    'Fr': 'Friday',
    'Sa':'Saturday',

    "jsgantt": {
        'january': 'January',
        'february': 'February',
        'march': 'March',
        'april': 'April',
        'maylong': 'May',
        'june': 'June',
        'july': 'July',
        'august': 'August',
        'september':'September',
        'october': 'October',
        'november': 'November',
        'december': 'December',

        'jan':  'January',
        'feb': 'February',
        'mar': 'March',
        'apr':  'April',
        'may': 'May',
        'jun': 'June',
        'jul': 'July',
        'aug': 'August',
        'sep': 'September',
        'oct': 'October',
        'nov': 'November',
        'dec': 'December',

        'Sunday': 'Sunday',
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday',
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',

        'Sun': 'Sunday',
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday',

        'resource': 'Assignee',
        'duration': 'Duration',
        'comp': 'Progress',
        'completion': 'Progress',
        'startdate': 'Start date',
        'enddate': 'End date',
        'moreinfo': 'More information required',
        'notes': 'Notes',
        'format':'Format',

        'hour': 'Hours',
        'day': 'Days',
        'week': 'Weeks',
        'month': 'Months',
        'quarter': 'Quarters',

        'hours': 'Hours',
        'days': 'Days',
        'weeks': 'Weeks',
        'months': 'Months',
        'quarters': 'Quarters',

        'hr':'Hours',
        'dy': 'Days',
        'wk': 'Weeks',
        'mth': 'Months',
        'qtr': 'Quarters',

        'hrs': 'Hours',
        'dys':'Days',
        'wks': 'Weeks',
        'mths': 'Months',
        'qtrs':'Quarters',

        'tooltipTemplate': 'Loading…',
    },
    //Calendar
    'Th 2' : 'Monday',
    'Th 3' : 'Tuesday',
    'Th 4' : 'Wednesday',
    'Th 5' : 'Thursday',
    'Th 6' : 'Friday',
    'Th 7' : 'Saturday',
    'location' : 'Location',
    'create_event' : 'Create a new meeting',
    'edit_event' : 'Edit meeting',
    'detail_event' : 'Meeting details',
    'save' : 'Save',
    'return' : 'Return',
    'delete' : 'Delete',
    'delete_event' :'Delete meeting',
    'edit' :'Edit',
    'created_by' : 'Create by',

    // Timekeeping management
    "file_content_invalid" :'Invalid file format',
    "require_timekeeping_file_format" : 'Please choose file uploaded is in .txt or .csv format',

    // Evaluation Result
    "subsection" : 'Subsection',
    "evaluators" : 'Evaluators',
    'required': 'Please complete all required fields',
    'max_255': 'Maximum 255 characters',
    "unique" :'Is already in use',
    "confirm_redirect": 'Do you want to save your changes?',
    "yes":'Yes',
    "no": 'No',
    "confirm_exit" : 'Changes you made may not be saved. Do you want to exit?',
    'evaluatee_placeholder': 'Please choose an evaluatee',
    'evaluator_placeholder': 'Please choose an evaluator',
    // Evaluation template
    'evaluatee_placeholder': 'Please choose an evaluatee',
    'evaluator_placeholder': 'Please choose an evaluator',
    "confirm_copy_evaluation": 'Are you sure you want to copy this evaluation?',
    "confirm_copy_template": 'Are you sure you want to copy this template?',
    'position_edit_succeed' : 'Edit position successful',
    'resource_edit_succeed' : 'Edit resource successfully',
    "confirm_copy_evaluation": 'Are you sure you want to copy this evaluation?',
    // Order
    'delete_order' : 'Delete order',
    'confirm_deletion_order' : 'Are you sure you want to delete this order?',
    'required_comment' : 'The note field is required.',
    'select_required': 'Please choose :attribute!',
    'Please_choose_a_dish' : 'Please choose a dish!',
    'Please_enter_the_dish' : 'Please enter the dish!',
    'Please_enter_employee_name':'Please enter employee name!',
    'please_enter_option': 'Please enter the option!',
    'employee_exist':'Employee has already placed an order',
    'Please_choose_month' : 'Please choose a month and year!',
    'Date_format_error' : 'Please select the correct format MM/YYYY',
    'Error_maxlength_option':'Please enter a length no more than 1000 characters',
    // Validate form create, edit task
    'please_enter_estimated_time' : 'Please enter the estimated time!',
    'please_enter_title_task' : 'Please enter the title of the task!',
    'please_enter_project' : 'Please select a project!',
    'please_enter_type' : 'Please select a category!',
    'please_enter_status' : 'Please select a status!',
    'please_enter_priority' : 'Please select a priority!',
    // Request
    'please_enter_bta' : 'Please enter the BTA',
    'Error_max_bta' : 'Please enter below 900.000.000',
    'before_or_equal' : 'The :attribute must be before or equal to :date.',
    'after_or_equal' : 'The :attribute must be after or equal to :date.',

    'vacation': 'Vacation',

    'max_name_property_type': '',
    // Task of the day
    'task': 'Task',
    'please_enter_name_property_management' : '',
    'max_name_property_management': '',
    //department
    "department": 'Department name',
    "department_code": "Department code",
    //property type
    "please_enter_name": "Please enter the :attribute !",
    "property_type_name": "Asset type name",
    "property_type_code": "Asset code header",
    "max_length": "The :attribute may not be greater than :max characters.",
    'property_status_name': 'Asset status name',
    "property_agency_name": "Unit name",
    "not_in": "The selected :attribute is invalid.",
    'asset_name': 'Asset name',
    'name_in_contract': 'Asset name (as per contract)',
    "name_short": "Abbreviated asset name",
    "management_unit_id": "Asset management unit",
    "type_id": "Asset type",
    "department_id" : "Utilization unit",
    "user_use_asset": "User",
    'asset_code': 'Asset code',
    "handover_record_code": "Handover protocol number",
    "seri_number": "Serial number",
    "supplier": "Supplier",
    "manufacturer": "Manufacturer",
    "manufacturing_date": "Manufacturing date",
    "asset_category": "Category",
    "usage_date": "Usage date",
    "purchase_date": "Purchase date",
    "condition_id": "Status",
    "source_of_origin": "Formation source",
    "asset_location": "Location",
    "asset_description": "Description",
    "residual_value" : "Remaining value",
    "original_price" : "Original value",
    "premises": "Branch",
    "country_of_manufacture": "Manufacturing country",
    'max_file' : 'The :attribute may not be greater than :max megabyte.!',
    'mimes_file' : 'The :attribute must be a file of type: :values.',
    "asset_image" : "Image",
    "asset_file": "Attached files",
    "asset_note": "Note",
    "asset_branch": "Branch",
    "asset_resource": "Formation source",
    "asset_bidding_package_name": "Package Name",
    "asset_bidding_package_code": "Package Code",
    "add_task": "Add Task",
    "enter_task_name": "Fill task title",
    "close" : "Close",
    //Customer
    "customer_name": "customer name",
    // evaluation
    "evaluation_template": "Evaluation template",
    "evaluator": "Evaluator",
    "evaluatee": "Evaluated person",
    "evaluation_finalizer": "Finalizer",
    "evaluation_form_name": "Name of evaluation form",
    "considering_the_time_period": "Considering in the time period",
    "evaluation_deadline": "Evaluation deadline",
    "apply_for": "Evaluated person",
    "evaluation_type": "Evaluations type",
    "evaluatee_duplicate": "The people being evaluated cannot be duplicated.",
    "evaluator_duplicate": "The evaluator cannot be duplicated.",
    "invalid_date_range": "Please enter correct date format (dd/mm/yyyy - dd/mm/yyyy)",
    "evaluation_deadline_after_considering_the_time_period": "Please enter the evaluation deadline at or after the evaluation time",
    "deadline_must_be_after_evaluation_time": "Cannot change the start date of the evaluation deadline during the evaluation period.",
    "add": "Add",
    "remove": "Remove",
    'actual_time': 'Actual time',
    'min_numeric': 'Please enter :attribute greater than or equal to :min!',
    //work schedule collaborator
    "max_shifts": "Maximum of 5 working shifts",

    //Vacation validation messages
    "vacation_block_two_hours": "Leave hours must be a multiple of 2.",
    "vacation_working_hours": "Leave time must be within your working hours.",
    "vacation_time_order": "Leave hours must not be zero.",
    // Checklist
    "performer": "Performer",
};
export default en;




// WEBPACK FOOTER //
// ./resources/build/js/locales/en.js